import React, { useState } from "react";
import "../../../styles/utils/modal/ImageComparisonModal.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

export default function ImageComparisonModal({
  oldImage,
  newImage,
  oldContent,
  newContent,
  onApply,
  onCancel,
}) {
  const { t } = useAppTranslation("components/utils/imageComparisonModal");
  const [selected, setSelected] = useState(null);

  const handleComplete = () => {
    if (selected === "before") {
      onCancel();
    } else if (selected === "after") {
      onApply();
    }
  };

  return (
    <div className="image-comparison-modal-overlay">
      <div className="modal-container">
        <h2>{t("title")}</h2>

        <div className="comparison-wrap">
          <div
            className={`compare-side before ${selected === "before" ? "selected" : ""}`}
            onClick={() => setSelected("before")}
          >
            <div className="label before-label">{t("labels.before")}</div>
            <div className="image-box">
              <img src={oldImage} alt={t("alts.beforeImage")} />
            </div>
            <div className="content-box">
              <p>{oldContent}</p>
            </div>
          </div>
          <div
            className={`compare-side after ${selected === "after" ? "selected" : ""}`}
            onClick={() => setSelected("after")}
          >
            <div className="label after-label">{t("labels.after")}</div>
            <div className="image-box">
              <img src={newImage} alt={t("alts.afterImage")} />
            </div>
            <div className="content-box">
              <p>{newContent}</p>
            </div>
          </div>
        </div>

        <div className="button-group">
          <button
            className={`complete-btn ${selected ? "active" : ""}`}
            onClick={handleComplete}
            disabled={!selected}
          >
            {t("actions.complete")}
          </button>
        </div>
      </div>
    </div>
  );
}
